import React from "react";

export const Contact = (props) => {
  return (
    <div>
      <section id="contact">
        <div className="container">
          <div className="contact-heading">
            <span className="section-kicker">LET’S BUILD SOMETHING</span>
            <h2>Have a project in mind?</h2>
            <p>Tell us what you’re working on. We’d love to hear about it.</p>
            <a className="contact-email page-scroll" href={props.data ? `mailto:${props.data.email}` : "#page-top"}>
              Get in touch <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
          <div className="contact-details">
            <div className="contact-item">
              <span><i className="fa fa-map-marker" aria-hidden="true"></i> ADDRESS</span>
              <p>{props.data ? props.data.address : "loading"}</p>
            </div>
            <div className="contact-item">
              <span><i className="fa fa-phone" aria-hidden="true"></i> PHONE</span>
              <p><a href={props.data ? `tel:${props.data.phone}` : "#contact"}>{props.data ? props.data.phone : "loading"}</a></p>
            </div>
            <div className="contact-item">
              <span><i className="fa fa-envelope-o" aria-hidden="true"></i> EMAIL</span>
              <p><a href={props.data ? `mailto:${props.data.email}` : "#contact"}>{props.data ? props.data.email : "loading"}</a></p>
            </div>
          </div>
          <div className="contact-bottom">
            <a href={props.data ? props.data.linkedin : "#contact"} target="_blank" rel="noreferrer" aria-label="Maitri Tech Solutions on LinkedIn">
              <i className="fa fa-linkedin" aria-hidden="true"></i> LinkedIn
            </a>
            <span>Let’s make technology work for you.</span>
          </div>
        </div>
      </section>
      <div id="footer">
        <div className="container text-center">
          <a className="footer-brand page-scroll" href="#page-top">MAITRI TECH</a>
          <p>&copy; 2020 Maitri Tech Solutions <span>·</span> Built with care.</p>
        </div>
      </div>
    </div>
  );
};
